import {
    REQUEST_STATUS,
    SET_LOADING_STATUS,
    CLEAR_STATUS,
    HIDE_MENU_ITEMS,
    SHOW_MENU_ITEMS,
    SHOW_ERROR_MESSAGE,
    HIDE_ERROR_MESSAGE, SHOW_LICENSE_DIALOG, HIDE_LICENSE_DIALOG,
} from '../../constants/global';

export const requestStatus = (status) => ({
    type: REQUEST_STATUS,
    status,
});

export const setLoadingStatus = (loading) => ({
    type: SET_LOADING_STATUS,
    loading,
});

export const clearStatus = () => ({
    type: CLEAR_STATUS
});


export const hideMenuItems = () => ({
    type: HIDE_MENU_ITEMS
});

export const showMenuItems = () => ({
    type: SHOW_MENU_ITEMS
});

export const showErrorMessage = (message) => ({
    type: SHOW_ERROR_MESSAGE,
    message
});

export const hideError = () => ({
    type: HIDE_ERROR_MESSAGE,
});

export const showLicenseDialog = () => ({
    type: SHOW_LICENSE_DIALOG,
});

export const hideLicenseDialog = () => ({
    type: HIDE_LICENSE_DIALOG,
});


